const basenameWithoutQuery = (url: string): string => {
  const withoutQuery = url.split("?")[0] ?? "";
  const segments = withoutQuery.split("/");
  return segments[segments.length - 1] ?? "";
};

const filenameStem = (filename: string): string => {
  const lastDotIndex = filename.lastIndexOf(".");
  return lastDotIndex > 0 ? filename.slice(0, lastDotIndex) : filename;
};

type MediaWithReplaceHistory = {
  filename?: string | null;
  metadata?: { replaceHistory?: unknown } | string | null;
};

const normalizedMetadata = (
  metadata: MediaWithReplaceHistory["metadata"],
): { replaceHistory?: unknown } | null => {
  if (typeof metadata !== "string") return metadata ?? null;
  try {
    const parsed: unknown = JSON.parse(metadata);
    return typeof parsed === "object" ? parsed : null;
  } catch {
    return null;
  }
};

export const hasBeenReplaced = (media: MediaWithReplaceHistory): boolean => {
  const metadata = normalizedMetadata(media.metadata);
  return Array.isArray(metadata?.replaceHistory) && metadata.replaceHistory.length > 0;
};

export const freshDerivedUrl = (
  media: MediaWithReplaceHistory,
  derivedUrl?: string | null,
): string | undefined =>
  derivedUrl && !isDerivedMediaUrlStale(media, derivedUrl) ? derivedUrl : undefined;

export const isDerivedMediaUrlStale = (
  media: MediaWithReplaceHistory,
  derivedUrl?: string | null,
): boolean => {
  if (!hasBeenReplaced(media)) return false;
  if (!media.filename || !derivedUrl) return false;

  const stem = filenameStem(media.filename);
  if (!stem) return false;

  return !basenameWithoutQuery(derivedUrl).includes(stem);
};
